import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { isStreamsData, StreamsData } from '../data.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'youtube-stream',
  props: {"enabled": {type: Boolean, default: true}, streams: [Object, String], name: String},
  setup(__props) {

const props = __props;



const REPLACER_DEFAULTS: { [key: string]: boolean | number } = {
  autoplay: true,
  mute: true,
  controls: true
};

const PARAM_MAP: { [key: string]: boolean | string } = {
  "0": false,
  "1": true,
  "true": "1",
  "false": "0"
}

const YOUTUBE_BASE = "https://www.youtube-nocookie.com/embed/{streamid}?autoplay={autoplay}&controls={controls}&mute={mute}";

const url = computed(() => {
  let url;
  let streamid;
  if (props.name && props.streams && props.streams instanceof Object && isStreamsData(props.streams as StreamsData)) {
    streamid = (props.streams as StreamsData).data[props.name].id
  }
  if (streamid) {
    let config = { streamid };
    url = YOUTUBE_BASE;
    let replKeys = YOUTUBE_BASE.matchAll(/\{([^\}]*)\}/g);

    let repl;
    while (repl = replKeys.next()) {
      if (repl.done) break;
      const replKey: string = repl.value[1];
      let replValue: any = Object.keys(config).indexOf(replKey) !== -1
        ? (config as { [key: string]: any })[replKey]
        : REPLACER_DEFAULTS.hasOwnProperty(replKey)
          ? REPLACER_DEFAULTS[replKey]
          : "";

      replValue = replValue.toString();
      switch (replKey) {
        case "mute":
        case "controls":
        case "autoplay":
          replValue = PARAM_MAP[replValue];
          break;
        default:
          break;
      }

      url = url.replace(repl.value[0], replValue);
    }
  }
  return url;
})


return { __sfc: true,props, REPLACER_DEFAULTS, PARAM_MAP, YOUTUBE_BASE, url }
}

})